import chat from "#/src/assets/svg/chat.svg";
import {useData} from "vike-react/useData";
import {ApiArticleComment, ApiBlogPostData} from "#/src/definitions/ApiDefinitions";
import {usePageContext} from "vike-react/usePageContext";
import {AppPageContext, DataWrapped} from "#/src/definitions/AppDefinitions";
import {Sort} from "#/src/utils/sort-utils";
import React, {useEffect, useState} from "react";
import AppConstants from "#/src/utils/app-constants";
import {composeHeaders} from "#/src/utils/api-request-utils";
import {toast} from "react-toastify";
import {Comment} from "#/src/pages/blog/@id/Comment";
import styled from "@emotion/styled";

const CommentTextarea = styled.textarea`
  resize: none;
`;

const Disclaimer = styled.div`
  color: #eef5f8;
  margin-top: .75rem;
  margin-left: auto;
  font-size: .75em;
  text-align: right;
  
  @media(max-width: 576px) {
    text-align: left !important;
  }
`;

const DisclaimerAnchor = styled.a`
  text-decoration: none;
  color: #ef1828;
`;

export function Comments() {
  const pageContext = usePageContext() as AppPageContext;
  const {user} = pageContext;
  const {data: postData} = useData() as DataWrapped<ApiBlogPostData>;
  const [comments, setComments] = useState<ApiArticleComment[]>([]);
  const [replyBox, setReplyBox] = useState<ApiArticleComment | null>(null);
  useEffect(() => {
    if (postData) {
      setComments(postData.comments);
    }
  }, [postData]);

  async function onRefetch() {
    const response = await fetch(`${AppConstants.API_ROUTE}/blog/${postData.article.slug}/comments`, {
      method: "GET",
      headers: composeHeaders(pageContext)
    });
    if (response.ok) {
      setComments(await response.json());
    }
  }

  async function onPost(replyTo: string | null = null) {
    let textareaForm: HTMLTextAreaElement | HTMLInputElement;
    if (replyTo == null) {
      textareaForm = document.getElementById("formComment") as HTMLTextAreaElement;
    } else {
      textareaForm = document.getElementById(`formReplyTo${replyTo}`) as HTMLInputElement;
    }
    const message = textareaForm.value;
    if (message.length === 0) {
      toast("Wiadomość musi być dłuższa!");
      return;
    }
    const response = await fetch(`${AppConstants.API_ROUTE}/blog/${postData.article.slug}/comments`, {
      method: "POST",
      headers: composeHeaders(pageContext),
      body: JSON.stringify({message, articleId: postData.article.id, replyTo})
    });
    if (response.ok) {
      textareaForm.value = "";
      setReplyBox(null);
      await onRefetch();
    } else {
      const errorResponse = await response.json() as any;
      if (errorResponse.errors) {
        errorResponse.errors.forEach(err => toast(err));
      }
    }
  }

  function render() {
    return <section className="comments-wrapper">
      <div className="container-xxl">
        <div className="row">
          <div className="col-xl-8">
            <div className="comments-title">
              <span>
                <img src={chat} alt="chat"/>
                <span className="text-primary"> {postData.comments.length}</span> Komentarzy
              </span>
            </div>
            {renderCommentBox()}
          </div>
        </div>
        {renderMessages()}
      </div>
    </section>
  }

  function renderCommentBox() {
    if (!user.loggedIn) {
      return <></>
    }
    return <div className="comments-add mt-3">
      <label htmlFor="formComment" className="form-label">Twój komentarz</label>
      <CommentTextarea className="form-control" rows={3} cols={3} id={"formComment"}/>
      <div className={"d-flex row"}>
        <div className={"col-12 col-sm-6 order-2 order-sm-1"}>
          <button type="button" className="btn btn-primary mt-3" onClick={() => onPost()}>Dodaj komentarz</button>
        </div>
        <div className={"col-12 col-sm-6 order-sm-2 order-1"}>
          <Disclaimer className={"comments-disclaimer"}>
            Dodając komentarz akceptujesz <DisclaimerAnchor href={"/regulamin"}>Regulamin</DisclaimerAnchor>
          </Disclaimer>
        </div>
      </div>
    </div>
  }

  function renderMessages() {
    if (comments.length === 0) {
      return <></>
    }

    return <div className="row">
      <div className="col-xl-12">
        <h4 className="comments-small-title">Wszystkie komentarze</h4>
      </div>
      <div className="col-xl-12">
        <div className="comments-content mt-3">
          {Sort.byDate(comments.filter(c => c.replyTo == null)).map((comment: ApiArticleComment) =>
            <Comment key={comment.id} comments={comments} comment={comment} replyBox={replyBox} setReplyBox={setReplyBox} onPost={onPost}/>
          )}
        </div>
      </div>
    </div>
  }

  return render();
}